import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  Form,
  Breadcrumb,
} from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import Fieldset from "./Fieldset";
import SearchableDropdown from "./SearchableDropdown";
import LeadEvents from "./LeadEvents";
import { useLocation } from "react-router-dom";
import {
  fetchOptions,
  fetchInitialData,
  fetchEditData,
  formFields,
  // tokenConfig,
  toastAttr,
  allocateMandap,
  showToastForUnavailableDates,
  checkAvailability,
  detectChanges,
} from "./utils";
import { toast, ToastContainer } from "react-toastify";
import config from "../../../config";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Breadcrumbs from "../../Helper/Breadcrumbs";

const OfflineLeadsForm = () => {
  const location = useLocation();
  const editMode = location?.state?.editMode || false;
  const leadId = location?.state?.id || null;
  const isUnlisted = location?.state?.isUnlisted || false;
  const history = useHistory();
  const tokenConfig = {
    headers: { Authorization: `Token ${sessionStorage.getItem("tokenKey")}` },
  };
  const [loading, setLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [kaeLoading, setKaeLoading] = useState(false);
  const [mandapLoading, setMandapLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [kaeOptions, setKaeOptions] = useState([]);
  const [mandapOptions, setMandapOptions] = useState([]);
  const [lead, setLead] = useState({
    kae: {},
    mandap: {},
    customerName: "",
    contactNumbers: [""],
    email: "",
    bookingPersonAddress: "",
    isUnlistedVenue: false,
    unlisted_venue_name: "",
    unlisted_venue_location: "",
    primaryEventType: "Wedding",
    primaryEventDate: new Date().toISOString().split("T")[0],
    remarks: "",
    leadEvents: [],
  });
  const [originalData, setOriginalData] = useState({
    kae: {},
    mandap: {},
    customerName: "",
    contactNumbers: [""],
    email: "",
    bookingPersonAddress: "",
    isUnlistedVenue: false,
    unlisted_venue_name: "",
    unlisted_venue_location: "",
    primaryEventType: "Wedding",
    primaryEventDate: new Date().toISOString().split("T")[0],
    remarks: "",
    leadEvents: [],
  });

  useEffect(() => {
    const loadInitialData = async () => {
      const data = await fetchInitialData(tokenConfig);
      setKaeOptions(data.kaeOptions);
      setMandapOptions(data.mandapOptions);

      setLoading(false);
    };
    loadInitialData();
  }, []);

  useEffect(() => {
    if (!editMode || !leadId) {
      return;
    }
    // if (editMode && leadId) {
    //   const loadEditData = async () => {
    //     const data = await fetchEditData(leadId);
    //     if (data) {
    //       setLead(data);
    //       setOriginalData(data);
    //     }
    //     setLoading(false);
    //   };
    //   loadEditData();
    // }
    const loadEditData = async () => {
      try {
        const data = await fetchEditData(leadId, tokenConfig, isUnlisted);
        if (data) {
          setLead(data);
          setOriginalData(data);
        }
      } catch (error) {
        console.error("Error fetching edit data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadEditData();
  }, [editMode, leadId]);
  // Reactive Auto-population for Agent Name
  useEffect(() => {
    if (kaeOptions?.length > 0 && !lead.kae?.id && !editMode) {
      const sessionKeys = ["userName", "username", "user_name"];
      const sessionNames = sessionKeys.map(k => sessionStorage.getItem(k)).filter(Boolean);

      const permissionStr = sessionStorage.getItem("permission");
      let permissionUserObj = null;
      try {
        if (permissionStr) {
          const permissions = JSON.parse(permissionStr);
          permissionUserObj = permissions[0]?.user_id;
          if (permissionUserObj?.username) sessionNames.push(permissionUserObj.username);
          if (permissionUserObj?.email) sessionNames.push(permissionUserObj.email);
        }
      } catch (e) {
        console.error("Error parsing permissions for auto-population:", e);
      }

      const uniqueSessionNames = Array.from(new Set(sessionNames.map(s => s.toLowerCase().trim())));

      console.group("Agent Auto-population Diagnostics (Reactive)");
      console.log("Session Candidates:", uniqueSessionNames);
      console.log("Available KAE Options:", kaeOptions);

      const matchingAgent = kaeOptions.find(agent => {
        const agentUsername = agent.username?.toLowerCase().trim();
        const agentFirstName = agent.first_name?.toLowerCase().trim();
        const agentFullName = `${agent.first_name || ""} ${agent.last_name || ""}`.toLowerCase().trim();
        const agentEmail = agent.email?.toLowerCase().trim();
        const agentDisplayName = agent.name?.toLowerCase().trim();

        return uniqueSessionNames.some(name =>
          name === agentUsername ||
          name === agentFirstName ||
          name === agentFullName ||
          name === agentEmail ||
          name === agentDisplayName
        );
      });

      if (matchingAgent) {
        console.log("Match Found! Auto-populating:", matchingAgent);
        setLead(prev => ({ ...prev, kae: matchingAgent }));
      } else {
        console.warn("No match found among session candidates.");
      }
      console.groupEnd();
    }
  }, [kaeOptions, editMode]); // Runs when kaeOptions are loaded or editMode changes

  const handleInputChange = (field, value) => {
    setLead((prevLead) => ({
      ...prevLead,
      [field]: value,
    }));
  };

  const handleContactNumberChange = (index, value) => {
    const updatedNumbers = [...lead.contactNumbers];
    updatedNumbers[index] = value;
    setLead((prev) => ({ ...prev, contactNumbers: updatedNumbers }));
  };

  const addContactNumber = () => {
    setLead((prev) => ({
      ...prev,
      contactNumbers: [...prev.contactNumbers, ""],
    }));
  };

  const removeContactNumber = (index) => {
    if (lead.contactNumbers.length > 1) {
      const updatedNumbers = lead.contactNumbers.filter((_, i) => i !== index);
      setLead((prev) => ({ ...prev, contactNumbers: updatedNumbers }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const missedFields = [];

    if (!lead?.kae?.id) {
      newErrors.kae = "Agent is required";
      missedFields.push("Agent Name");
    }

    if (lead.isUnlistedVenue) {
      if (!lead.customerName) {
        newErrors.customerName = "Lead name is required";
        missedFields.push("Lead Name");
      }
      if (!lead.contactNumbers || !lead.contactNumbers[0]) {
        newErrors.contactNumber = "Contact Number is required";
        missedFields.push("Contact Number");
      }
      // if (!lead.unlisted_venue_name) {
      //   newErrors.unlisted_venue_name = "Venue Name is required";
      //   missedFields.push("Venue Name");
      // }
      // if (!lead.unlisted_venue_location) {
      //   newErrors.unlisted_venue_location = "Venue Location is required";
      //   missedFields.push("Venue Location");
      // }
      // if (!lead.remarks) {
      //   newErrors.remarks = "Remarks are required";
      //   missedFields.push("Remarks");
      // }
    } else {
      if (!lead?.mandap?.id) {
        newErrors.mandap = "Mandap is required";
        missedFields.push("Venue Name");
      }

      formFields.forEach((field) => {
        if (field.required) {
          if (field.name === "contactNumber") {
            if (!lead.contactNumbers || !lead.contactNumbers[0]) {
              newErrors.contactNumber = "Contact Number is required";
              missedFields.push("Contact Number");
            }
          } else if (!lead[field.name] && field.name !== "contactNumber") {
            newErrors[field.name] = `${field.label} is required`;
            missedFields.push(field.label);
          }
        }
      });

      if (lead?.leadEvents?.length === 0) {
        newErrors.leadEvents = "At least one event is required";
        missedFields.push("Event Details");
      }
    }

    if (missedFields.length > 0) {
      toast.error(`Please fill in the following required fields: ${missedFields.join(", ")}`, {
        ...toastAttr,
        autoClose: 5000,
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submit clicked", lead);
    setSaveLoading(true);

    if (!validateForm()) {
      setSaveLoading(false);
      return;
    }

    const isEditMode = location?.state?.editMode;
    const leadId = location?.state?.id;

    if (lead.isUnlistedVenue) {
      const unlistedApiUrl = isEditMode
        ? `${config.service}/leads_v2/leads/${leadId}/`
        : `${config.service}/leads_v2/leads/`;
      const unlistedPayload = {
        kae: lead.kae,
        customer_name: lead.customerName,
        contact_number: lead.contactNumbers,
        booking_person_address: lead.bookingPersonAddress || "",
        is_unlisted_venue: true,
        unlisted_venue_name: lead.unlisted_venue_name,
        unlisted_venue_location: lead.unlisted_venue_location,
        primary_event_type: lead.primaryEventType || "Wedding",
        primary_event_date: lead.primaryEventDate || new Date().toISOString().split("T")[0],
        remarks: lead.remarks,
        email: lead.email || "",
      };

      try {
        const response = await axios({
          method: isEditMode ? "put" : "post",
          url: unlistedApiUrl,
          data: unlistedPayload,
          ...tokenConfig,
        });
        if (response.status === 200 || response.status === 201) {
          toast.success(`Unlisted venue lead ${isEditMode ? "updated" : "created"} successfully!`, { ...toastAttr, autoClose: 4000 });
          setSaveLoading(false);
          history.push({ pathname: "/offlineleads" });
        }
      } catch (error) {
        setSaveLoading(false);
        console.error(`Error ${isEditMode ? "updating" : "creating"} unlisted venue lead:`, error.response?.data || error.message);
        toast.error(error.response?.data?.message || "An error occurred. Please try again.", { ...toastAttr, autoClose: 4000 });
      }
      return;
    }

    const apiUrl = isEditMode
      ? `${config.service}/masters/offline_leads/update/${leadId}/`
      : `${config.service}/masters/offline_leads/create/`;

    const { leadEvents } = lead;
    const { leadEvents: originalLeadEvents } = originalData;

    const { updatedEvents, removedEvents } = detectChanges(
      originalLeadEvents,
      leadEvents
    );

    try {
      // Check availability for new/altered events
      for (const event of updatedEvents) {
        try {
          const availability = await checkAvailability(
            event,
            lead.mandap.id,
            isEditMode,
            tokenConfig
          );

          if (!availability.isAvailable) {
            showToastForUnavailableDates(
              event.event_date_from,
              availability.blockedTimes
            );
            setSaveLoading(false);
            return; // Stop further processing
          }
        } catch (error) {
          console.error(
            `Error checking availability for event on ${event.event_date_from
            }:${error.response?.data || error.message}`,
            error.response?.data || error.response?.data.message
          );
          setSaveLoading(false);
          // Show a generic error message if the API call itself fails unexpectedly
          toast.error(
            `Failed to check availability for event on ${event.event_date_from}. Please try again.`,
            { ...toastAttr, autoClose: 4000 }
          );
          return; // Stop further processing
        }
      }

      const dataToSend = {
        kae: lead.kae,
        mandap: lead.mandap,
        customer_name: lead.customerName,
        contact_number: lead.contactNumbers.join(","),
        booking_person_address: lead.bookingPersonAddress,
        is_unlisted_venue: lead.isUnlistedVenue,
        unlisted_venue_name: lead.unlisted_venue_name,
        unlisted_venue_location: lead.unlisted_venue_location,
        primary_event_type: lead.primaryEventType || "Wedding",
        primary_event_date: lead.primaryEventDate || new Date().toISOString().split("T")[0],
        remarks: lead.remarks,
        email: lead.email,
        lead_events: leadEvents.filter(
          (event) => !removedEvents.some((removed) => removed.id === event.id)
        ),
      };

      // let booking_id = null;
      let response;
      try {
        response = await axios({
          method: isEditMode ? "put" : "post",
          url: apiUrl,
          data: dataToSend,
          ...tokenConfig,
        });

        if (response.status === 200 || response.status === 201) {
          console.log("Lead saved successfully", response.data);
        }
      } catch (error) {
        if (error.response) {
          setSaveLoading(false);
          console.error("Error response:", error.response.data);
          if (
            error.response.data.errors &&
            error.response.data.errors.contact_number
          ) {
            toast.error(
              "Error: " + error.response.data.errors.contact_number.join(", "),
              { ...toastAttr, autoClose: 4000 }
            );
            return;
          } else {
            toast.error(
              "An error occurred: " + error.response.data.message ||
              "Unknown error",
              { ...toastAttr, autoClose: 4000 }
            );
            return;
          }
        } else if (error.request) {
          console.error("Error request:", error.request);
          toast.error("Network error: No response received from the server.", {
            ...toastAttr,
            autoClose: 4000,
          });
          setSaveLoading(false);
          return;
        } else {
          console.error("Error:", error.message);
          toast.error("Error: " + error.message, {
            ...toastAttr,
            autoClose: 4000,
          });
          setSaveLoading(false);
          return;
        }
      }

      // Allocate Mandap for updated events if not unlisted
      if (!lead.isUnlistedVenue) {
        for (const event of updatedEvents) {
          await allocateMandap(lead.mandap.id, event, true, null, tokenConfig);
        }

        // Unallocate Mandap for removed events
        for (const event of removedEvents) {
          await allocateMandap(lead.mandap.id, event, false, null, tokenConfig);
        }
      }

      toast.success(
        `Lead ${isEditMode ? "updated" : "created"
        } successfully and Mandap allocated!`,
        { ...toastAttr, autoClose: 4000 }
      );
      setSaveLoading(false);
      history.push({ pathname: "/offlineleads" });
    } catch (error) {
      setSaveLoading(false);
      console.error(
        "Error during submission:",
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again.",
        { ...toastAttr, autoClose: 4000 }
      );
    }
  };

  const handleEntitySelection = (selectedOption, type) => {
    console.log("selectedOption", selectedOption);
    console.log("type", type);
    setLead({ ...lead, [type]: selectedOption });
  };

  const fetchAllOptions = async (type, query) => {
    if (type === "kae") setKaeLoading(true);
    else if (type === "mandap") setMandapLoading(true);
    const options = await fetchOptions(type, query, tokenConfig);

    if (type === "kae") setKaeLoading(false);
    else if (type === "mandap") setMandapLoading(false);

    if (type === "kae") setKaeOptions(options);
    else if (type === "mandap") setMandapOptions(options);
  };

  const breadcrumbData = [
    { title: "Offline Leads", href: "/offlineleads" },
    {
      title: editMode ? "Edit Offline Lead" : "Create Offline Lead",
      href: "#",
    },
  ];

  if (loading)
    return (
      <Container
        className="w-100 d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <CircularProgress />
      </Container>
    );

  return (
    <Container>
      <Breadcrumbs data={breadcrumbData} />
      <Card>
        <Card.Body>
          <Fieldset title="Assignment Details">
            <Col md={12} className="mb-3">
              <Form.Check
                type="switch"
                id="unlisted-venue-switch"
                label="Unlisted Venue?"
                checked={lead.isUnlistedVenue}
                onChange={(e) =>
                  setLead((prev) => ({
                    ...prev,
                    isUnlistedVenue: e.target.checked,
                    mandap: e.target.checked ? { id: null, name: "", city: "", location: "", address: "", pincode: "" } : prev.mandap
                  }))
                }
              />
            </Col>
            {!lead.isUnlistedVenue ? (
              <>
                <Col md={6} sm={12}>
                  <Form.Group controlId="kae-group">
                    <Form.Label>Agent Name <span className="text-danger">*</span></Form.Label>
                    <SearchableDropdown
                      placeholder="Search and select Agent..."
                      options={kaeOptions}
                      value={lead.kae}
                      onSearch={(query) => fetchAllOptions("kae", query)}
                      onSelect={(selectedOption) =>
                        handleEntitySelection(selectedOption, "kae")
                      }
                      isLoading={kaeLoading}
                      disabled={false}
                      required={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={6} sm={12}>
                  <Form.Group controlId="mandap-group">
                    <Form.Label>Venue Name</Form.Label>
                    <div className="d-flex flex-column flex-sm-row align-items-end">
                      <SearchableDropdown
                        placeholder="Search and select Mandap..."
                        options={mandapOptions}
                        value={lead.mandap}
                        onSearch={(query) => fetchAllOptions("mandap", query)}
                        onSelect={(selectedOption) =>
                          handleEntitySelection(selectedOption, "mandap")
                        }
                        isLoading={mandapLoading}
                        disabled={editMode ? true : false}
                        required={true}
                      />
                      <LeadEvents
                        mandapId={lead?.mandap?.id || null}
                        onUpdateEvents={(events) =>
                          handleInputChange("leadEvents", events)
                        }
                        LeadEventData={lead?.leadEvents || []}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </>
            ) : (
              <>
                <Col md={4} sm={12}>
                  <Form.Group controlId="kae-group-unlisted">
                    <Form.Label>Agent Name <span className="text-danger">*</span></Form.Label>
                    <SearchableDropdown
                      placeholder="Search and select Agent..."
                      options={kaeOptions}
                      value={lead.kae}
                      onSearch={(query) => fetchAllOptions("kae", query)}
                      onSelect={(selectedOption) =>
                        handleEntitySelection(selectedOption, "kae")
                      }
                      isLoading={kaeLoading}
                      disabled={false}
                      required={true}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} sm={12}>
                  <Form.Group controlId="unlisted_venue_name">
                    <Form.Label>Venue Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter venue name"
                      value={lead.unlisted_venue_name}
                      onChange={(e) => handleInputChange("unlisted_venue_name", e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} sm={12}>
                  <Form.Group controlId="unlisted_venue_location">
                    <Form.Label>Venue Location</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter venue location"
                      value={lead.unlisted_venue_location}
                      onChange={(e) => handleInputChange("unlisted_venue_location", e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} sm={12} className="mt-3">
                  <Form.Group controlId="primaryEventType">
                    <Form.Label>Event Type</Form.Label>
                    <Form.Control
                      as="select"
                      value={lead.primaryEventType}
                      onChange={(e) => handleInputChange("primaryEventType", e.target.value)}
                    >
                      <option value="Wedding">Wedding</option>
                      <option value="Reception">Reception</option>
                      <option value="Engagement">Engagement</option>
                      <option value="Birthday">Birthday</option>
                      <option value="Other">Other</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6} sm={12} className="mt-3">
                  <Form.Group controlId="primaryEventDate">
                    <Form.Label>Event Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={lead.primaryEventDate}
                      onChange={(e) => handleInputChange("primaryEventDate", e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
            {lead?.leadEvents?.length > 0 && !lead.isUnlistedVenue && (
              <Col md={12} className="mt-2 text-center">
                <strong>Booked Slots:</strong>
                <ul>
                  {lead?.leadEvents?.map((event, index) => (
                    <li key={index} style={{ listStyleType: "none" }}>
                      {event?.event_date_from || event?.date} -{" "}
                      {event.event_date_to || event?.date}{" "}
                      {`(${event?.booking_type})`}
                    </li>
                  ))}
                </ul>
              </Col>
            )}
          </Fieldset>

          {!lead.isUnlistedVenue && (
            <Fieldset title="Mandap Information">
              {formFields.slice(0, 4).map((field) => (
                <Col md={6} key={field.name}>
                  <Form.Group controlId={field.name}>
                    <Form.Label>{field.label === "city" ? "City" : field.label}</Form.Label>
                    <Form.Control
                      type={field.type}
                      disabled
                      value={lead?.mandap[field.name]}
                      onChange={(e) =>
                        handleInputChange(field.name, e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
              ))}
            </Fieldset>
          )}

          <Fieldset title="Customer Information">
            <Row className="w-100 p-3">
              <Col md={6} sm={12}>
                <Form.Group controlId="customerName">
                  <Form.Label>Lead name (Bride/Groom) <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Name"
                    value={lead.customerName}
                    onChange={(e) => handleInputChange("customerName", e.target.value)}
                    isInvalid={errors["customerName"]}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors["customerName"]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} sm={12}>
                <Form.Group controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Email"
                    value={lead.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    isInvalid={errors["email"]}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-1 w-100 p-3">
              <Col md={6} sm={12}>
                <Form.Group controlId="contactNumbers">
                  <Form.Label>Contact Numbers <span className="text-danger">*</span></Form.Label>
                  {lead.contactNumbers?.map((number, index) => (
                    <div key={index} className="d-flex mb-2">
                      <Form.Control
                        type="text"
                        placeholder="Enter Contact Number"
                        value={number}
                        onChange={(e) => handleContactNumberChange(index, e.target.value)}
                        isInvalid={index === 0 && errors["contactNumber"]}
                      />
                      {index > 0 && (
                        <Button
                          variant="outline-danger"
                          className="ml-2"
                          onClick={() => removeContactNumber(index)}
                        >
                          -
                        </Button>
                      )}
                      {index === lead.contactNumbers.length - 1 && (
                        <Button
                          variant="outline-primary"
                          className="ml-2"
                          onClick={addContactNumber}
                        >
                          +
                        </Button>
                      )}
                    </div>
                  ))}
                  {errors["contactNumber"] && (
                    <div className="text-danger small">{errors["contactNumber"]}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} sm={12}>
                <Form.Group controlId="bookingPersonAddress">
                  <Form.Label>Address of the booking person</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Enter Address"
                    value={lead.bookingPersonAddress}
                    onChange={(e) => handleInputChange("bookingPersonAddress", e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Fieldset>

          <Fieldset title="Remarks">
            <Col md={12}>
              <Form.Group controlId="remarks">
                <Form.Label>Remarks</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  value={lead.remarks}
                  onChange={(e) => handleInputChange("remarks", e.target.value)}
                  isInvalid={errors["remarks"]}
                />
                <Form.Control.Feedback type="invalid">
                  {errors["remarks"]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Fieldset>

          <div className="d-flex flex-row align-items-center justify-content-start p-3">
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={saveLoading}
              className="d-flex align-items-center justify-content-center me-2"
            >
              {saveLoading ? "Saving..." : "Save"}
            </Button>
            <Button
              variant="secondary"
              onClick={() => history.push({ pathname: "/offlineleads" })}
            >
              Cancel
            </Button>
          </div>
        </Card.Body>
      </Card>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default OfflineLeadsForm;
